import { useEffect, useState } from "react";
import { ActionMeta } from "react-select";
import { useAppSelector } from "../../../../hooks/redux-hooks";
import BigOkButton from "../../Buttons/BigOkButton";
import FormSelectInput from "../../FormSelectInput";
import FormTextInput from "../../FormTextInput";
import { TitleContainer, Wrapper, NewDepForm, InputsContainer, ErrorSpan } from "./styles";
import departmentService from "../../../../service/departmentService";
import { useNavigate } from "react-router-dom";
import { SubmitHandler, useForm } from "react-hook-form";
import { InputDiv, StyledDialog } from "../EditDepartament/styles";
import { useMainContext } from "../../../../Contexts/Contexts";
import userService, { IRelationCompany } from "../../../../service/userService";
import { Button, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField } from "@mui/material";
import { Check } from "@mui/icons-material";
import { IoClose } from "react-icons/io5";
import React from "react";

interface FormItens {
  name: string;
  initials: string;
  selectedOptionCompany: string;
}

const NewDepartament: React.FC = () => {

  const nav = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm<FormItens>();

  const [optionsCompany, setOptionsCompany] = useState<Array<{ value: string; label: string; }>>([]);
  const [selectedOptionCompany, setSelectedOptionCompany] = useState<string>();
  const [companies, setCompanies] = useState<IRelationCompany[]>([]);
  const [companySelected, setCompanySelected] = useState<number>(0);
  const [actualDepartament, setActualDepartament] = useState<any>(null)
  const [companyName, setCompanyName] = React.useState<string>();

  const [departments, setDepartments] = useState<{ id: number, value: string }[]>([]);
  const companys = useAppSelector(state => state.chat.companys);
  const idContext = useMainContext();

  const searchDepartmentsByCompany = async (id: number) => {
    departmentService.getDepartmentByCompanyID(id).then(
      result => {

        if (!result) return;

        const departmentsOptionsFormatted = result.map((dep: { name: string; id: string; }) => {
          return { value: dep.name, id: parseInt(dep.id) }
        });

        setDepartments(departmentsOptionsFormatted);

      }
    );
  }

  useEffect(() => {

    userService.getRelationUserCompany().then(response => {


      const companies = response;
      const allCompanies = companies.map(company => company);
      setCompanies(allCompanies)

      if (response.length > 0) {

        const companySelect = parseInt(response[0].id_company);
        setCompanySelected(companySelect);

        searchDepartmentsByCompany(companySelect);
      }
    });
  }, []);

  useEffect(() => {
    departmentService.getDepartmentByID(parseInt(idContext.id!) || 0).then(result => {
      setActualDepartament(result)
    })
  }, [idContext.id])

  const onSubmit = (data: FormItens) => {
    try {
      departmentService.createDepartment({
        id_company: selectedOptionCompany as unknown as number,
        initials: data.initials,
        name: data.name
      }).then(result => {
        idContext.setUpdateDepartmentHandle(true)
        if (!result) {
          idContext.setPopupModalErrorOpen(true)
          idContext.setPopupModalErrorText('O nome utilizado já existe!');
        } else {
          idContext.setNewDepartmentOpen(false)
          idContext.setPopupModalText('Departamento Criado!');
          idContext.setPopupModalOpen(true)
        }
      })
    } catch (error) {
      idContext.setPopupModalErrorText('Parece que ocorreu algum erro no servidor, poderia tentar novamente?');
      idContext.setPopupModalErrorOpen(true);
    }
  }

  const handleChangeCompanySelect = (event: SelectChangeEvent<typeof companyName>) => {
    const {
      target: { value },
    } = event;
    setCompanyName(value);
    setSelectedOptionCompany(value);
  };
  useEffect(() => {

    const newCompanys: Array<{ value: string; label: string; }> = [];

    companies.forEach(e => {
      let newOption = {
        value: String(e.id_company),
        label: e.name_company,
      }
      newCompanys.push(newOption);
    })

    // setSelectedOptionCompany(newCompanys);
    setOptionsCompany(newCompanys)


  }, [companies]);
  const handleClose = () => {
    idContext.setNewDepartmentOpen(false)
  };
  const theme = localStorage.getItem('theme');

  return (
    <StyledDialog open={idContext.newDepartmentOpen} onClose={handleClose} sx={{ backdropFilter: 'none' }} data-theme={theme ? theme : 'light'}>
      <Wrapper>
        <TitleContainer>
          Novo Departamento
        </TitleContainer>


        <NewDepForm>
          <InputsContainer>
            {/*<FormTextInput
            label="Nome"
            placeholder="Nome da empresa"
            register={register}
            errors={errors.name}
            name='name'
            defaultValue={actualDepartament? actualDepartament.name : ''}
          />*/}
            <InputDiv>
              <TextField
                key="nameNewInput"
                autoFocus
                margin="dense"
                id="name"
                error={errors.name ? true : false}
                label="Nome"
                placeholder="Nome do Departamento"
                type="text"
                {...register("name", { required: true, max: 150, min: 2, maxLength: 150, minLength: 2 })}
                fullWidth
                variant="filled"
                InputLabelProps={{ shrink: true, style: { color: 'var(--text-modal)' } }}
              />
              {errors.name && <ErrorSpan>Este campo precisa de pelo menos dois caracteres!</ErrorSpan>}
            </InputDiv>

            <InputDiv>
              <TextField
                key="initialNewInput"
                margin="dense"
                id="initial"
                label="Sigla"
                error={errors.initials ? true : false}
                placeholder="Sigla do Departamento"
                type="text"
                fullWidth
                {...register("initials", { required: false, maxLength: 15, minLength: 2 })}
                variant="filled"
                InputLabelProps={{ shrink: true, style: { color: 'var(--text-modal)' } }}
              />
              {errors.initials && <ErrorSpan>Este campo precisa de pelo menos dois caracteres!</ErrorSpan>}
            </InputDiv>

            { /* <FormSelectInput
            label="Empresa"
            placeholder="Nome da empresa"
            options={optionsCompany}
            handleOnChange={handleCompanySelect}
        /> */}
            <FormControl sx={{ m: 1, minWidth: 120, width: '100%', alignSelf: 'center', color: 'red' }}>
              <InputLabel shrink={true} id="demo-simple-select-autowidth-label" sx={{ fontSize: '16px', color: 'var(--text-modal)' }} >Selecione a empresa</InputLabel>
              <Select
                key="selectNewInput"
                labelId="demo-simple-select-label"
                id="demo-simple-select-autowidth"
                autoWidth
                displayEmpty
                value={companyName ? companyName : ''}
                onChange={handleChangeCompanySelect}
                input={<OutlinedInput sx={{ color: "red" }} id="demo-simple-select-label" label="Selecione a empresa" />}
                sx={{
                  backgroundColor: 'var(--input-bg-color)', width: '100%', color: "var(--text-modal)", '.MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(228, 219, 233, 0.25)',
                  },
                }}
              >

                <MenuItem disabled={true} value="">
                  <em>Selecione a empresa</em>
                </MenuItem>

                {optionsCompany.map(e => (
                  <MenuItem value={e.value}> {e.label} </MenuItem>
                ))}

              </Select>
            </FormControl>

          </InputsContainer>

          <div style={{ display: 'flex', gap: "1rem", padding: '1rem 0', alignSelf: 'right', justifyContent: 'right', width: '100%' }}>
            <Button sx={{ color: 'var(--primary)' }} color="secondary" onClick={handleClose} startIcon={<IoClose />}>Fechar</Button>

            <Button variant="contained" color="success" onClick={handleSubmit(onSubmit)} startIcon={<Check />}>Criar departamento</Button>
          </div>

        </NewDepForm>
      </Wrapper> </StyledDialog>
  );
};

export default NewDepartament;
